import { render } from "./ChannelRaid.vue?vue&type=template&id=099ecb1a"
import script from "./ChannelRaid.vue?vue&type=script&lang=ts"
export * from "./ChannelRaid.vue?vue&type=script&lang=ts"
script.render = render

export default script